<template>
	<button class="button flex gap-xs v-center">
		<slot></slot>
	</button>
</template>

<script>
	export default {
		name: 'Button',
	}
</script>

<style lang="scss">
	.button{  
		display: inline-flex;
		position: relative;
		border-radius: 100px;
		padding: 8px;
		white-space: nowrap;
		cursor: pointer;
		background: var(--black);
		color: var(--white);
		font-size: 1rem;
		border: none;
		outline: none;
		text-decoration: none;
		transition: background 0.2s;
		align-self: start;
		
		&:hover{
			background: #666666;
		}
		
		&[disabled], 
		&.disabled{
			opacity: 0.5;
			pointer-events: none;
		}
		
		&[secondary], 
		&.secondary{
			background: var(--white);
			color: var(--black);
			
			&:hover{
				background: #CCCCCC;
			}
		}
		
		&[outlined], 
		&.outlined{
			outline: 2px solid black;
			background: var(--white);
			color: var(--black);
			
			&:hover{
				background: #CCCCCC;
			}
		}
	}
	
</style>
